import { render, staticRenderFns } from "./contentAdd.vue?vue&type=template&id=e4c803dc&scoped=true"
import script from "./contentAdd.vue?vue&type=script&lang=js"
export * from "./contentAdd.vue?vue&type=script&lang=js"
import style0 from "./contentAdd.vue?vue&type=style&index=0&id=e4c803dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c803dc",
  null
  
)

export default component.exports